import { ActionName } from "@faire/web--source/common/performance/userPerceivedLoadTiming/types";
import React from "react";

type PrehydrationClickLocation =
  | "filter-sidebar"
  | "filter-row"
  | `product-tile-${string}`;

export const PrehydrationClickTrackingWrapper = ({
  name,
  isRsc,
  location,
  className,
  children,
}: {
  name: ActionName;
  isRsc: boolean;
  location: PrehydrationClickLocation;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <>
      <div
        data-prehydration-on-click={`trackEvent && trackEvent("retailers-prehydration_click-click", [
          "${name}",
          ${isRsc ? '"true"' : '"false"'},
          "${location}"
        ])`}
        onClick={() => {}} // do not fire the click event after hydration
        className={className}
      >
        {children}
      </div>
      {/* This only does anything if the page is server rendered. It has no effect on the client. */}
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: getClickTrackingScript(),
        }}
      />
    </>
  );
};

/**
 * This is run in server-rendered contexts.
 * This script is used to convert data-prehydration-on-click attributes to onclick attributes
 * which will be fired even when no JS is enabled. This is to track clicks before hydration.
 */
const getClickTrackingScript = () => `
  document.querySelectorAll('[data-prehydration-on-click]').forEach(el => {
    const dataOnClick = el.getAttribute('data-prehydration-on-click');
    el.setAttribute('onclick', dataOnClick);
  });
`;
